import React, {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState
} from 'react';
import { useSearchParams } from 'react-router-dom';

interface IApprovalPasswordContext {
  password: string | null;
  setPassword: (password: string | null) => void;
}

const ApprovalPasswordContext = createContext<IApprovalPasswordContext>(
  undefined as any
);

const defaultContext: IApprovalPasswordContext = {
  password: null,
  setPassword: () => {
    // No-op
  }
};

export function useApprovalPassword(): IApprovalPasswordContext {
  return useContext(ApprovalPasswordContext) ?? defaultContext;
}

interface ApprovalPasswordProviderProps {
  readonly children: ReactNode;
}

export function ApprovalPasswordProvider({
  children
}: ApprovalPasswordProviderProps) {
  const [searchParams] = useSearchParams();
  const awId = searchParams.get('id');

  const [password, setPasswordState] = useState<string | null>(() => {
    return localStorage.getItem(`asset-review-password-${awId}`);
  });

  const setPassword = useCallback(
    (newPassword: string | null) => {
      const key = `asset-review-password-${awId}`;
      if (newPassword) localStorage.setItem(key, newPassword);
      else localStorage.removeItem(key);
      setPasswordState(newPassword);
    },
    [awId]
  );

  const contextValue = useMemo<IApprovalPasswordContext>(
    () => ({ password, setPassword }),
    [password, setPassword]
  );

  return (
    <ApprovalPasswordContext.Provider value={contextValue}>
      {children}
    </ApprovalPasswordContext.Provider>
  );
}
